export function buildAuthorName(user?: {
    firstName?: string;
    lastName?: string;
}): string {
    if (!user) {
        return "Unknown User";
    }

    const firstName = user.firstName?.trim() || "";
    const lastName = user.lastName?.trim() || "";

    if (firstName && lastName) {
        return `${ firstName } ${ lastName }`;
    }

    if (firstName) {
        return firstName;
    }

    if (lastName) {
        return lastName;
    }

    // Intentionally fall back to a generic label rather than the username, which is commonly an
    // email address and could expose data the viewer should not see.
    return "Unknown User";
}
